/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Meeting_OverInputs */



/**
* | output |
* | --- |
* | "This meeting is already over, so there is nothing left to prepare." |
*
* @param {Meeting_Prep_Meeting_OverInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_meeting_over = /** @type {((inputs?: Meeting_Prep_Meeting_OverInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Meeting_OverInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze afspraak is al voorbij, dus er valt niets meer voor te bereiden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette réunion est déjà terminée, il n'y a donc plus rien à préparer.")
	return /** @type {LocalizedString} */ ("This meeting is already over, so there is nothing left to prepare.")
});